import { AfterViewInit, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-note-editor-dialog',
  templateUrl: './note-editor-dialog.component.html',
})
export class NoteEditorDialog implements AfterViewInit {
  @ViewChild('noteTextbox') noteTextbox?: ElementRef;

  public note: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<NoteEditorDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {
      label: string | null,
      note: string | null
    }
  ) {
    this.note = data.note;
  }

  ngAfterViewInit(): void {
    var element = (<HTMLInputElement>this.noteTextbox?.nativeElement);
    setTimeout(() => {
      element.value = this.note || '';
      element.focus();
      element.select();
    });
  }

  onConfirmClick() {
    this.dialogRef.close(this.noteTextbox!.nativeElement.value);
  }
}
